function cartEvents() {
  const {
    freeGwpProductIdTier1,
    freeGwpProductTier1InStock,
    freeGwpThresholdTier1,
    freeGwpThresholdTier2,
    freeGwpProductIdTier2,
    freeGwpProductTier2InStock,
    gwpSectionThreshold,
  } = ACDC.Data;

  const gwpSectionProductsContainer = document.querySelector('.gwp-section-products-container')
  const gwpSectionProducts = gwpSectionProductsContainer.getAttribute('data-gwp-product-ids')
  const gwpProductArray = gwpSectionProducts.split('-')

  // initial check for Gwp Section  in mini cart
  fetch("/cart.js")
    .then((resp) => resp.json())
    .then((json) => {
      let totalCartPrice = 0;
      let cartItems;
      totalCartPrice = json.total_price;
      cartItems = json.items;
      toggleGwpSection(totalCartPrice);
      handleGWPCartActions(cartItems)
    });

  function init() {
    addEvents();
  }

  function addEvents() {
    let resolved = true;

    document.addEventListener("cart:updated", () => {
      document.dispatchEvent(new CustomEvent("cart:build"));
      fetch("/cart.js")
        .then((resp) => resp.json())
        .then((json) => {
          let totalCartPrice = 0;
          let cartItems;
          totalCartPrice = json.total_price;
          cartItems = json.items;
          removeGwpItem(totalCartPrice);
          addGwpItem(totalCartPrice, cartItems);
          toggleGwpSection(totalCartPrice);
          handleGWPCartActions(cartItems)
          removeGwpSectionItem(totalCartPrice, cartItems)
        });
    });

    document.addEventListener("ajaxProduct:added", () => {
      document.dispatchEvent(new CustomEvent("cart:build"));
      setTimeout(() => {

      if (resolved === true) {
        resolved = false;
        fetch("/cart.js")
          .then((resp) => resp.json())
          .then((json) => {
            let totalCartPrice = 0;
            let cartItems;
            totalCartPrice = json.total_price;
            cartItems = json.items;
            addGwpItem(totalCartPrice, cartItems);
            toggleGwpSection(totalCartPrice);
            handleGWPCartActions(cartItems)
          });
        setTimeout(() => {
          resolved = true;
        }, 3000);
      }
    }, 700)
    });

    document.addEventListener("cart:updated", () => {
      document.dispatchEvent(new CustomEvent("cart:build"));
    });
  }

  // GWP section functions
  // function to show and hide gift with purchase section
  function toggleGwpSection(totalCartPrice) {
    if (gwpSectionThreshold) {
      const gwpSection = document.querySelector(".minicart-gwp-wrap");
      if (gwpSection !== null){
        if (
          gwpSectionThreshold != "" &&
          Number(totalCartPrice) >= Number(gwpSectionThreshold)
        ) {
          gwpSection.style.display = "block";
        } else {
          gwpSection.style.display = "none";
        }
      }
    }
  }

    // function to disbale gift with purchase add to cart options and update text if they are present in current cart
    function handleGWPCartActions(cartItems) {
      let hasGwpItem = false
      const GWPAddToCartWrappers = document.querySelectorAll('.minicart-gwp')

      gwpProductArray.forEach(gwpProductId => {
        if (cartItems.filter((item) => item.id == parseInt(gwpProductId)).length > 0){
          hasGwpItem = true

          GWPAddToCartWrappers.forEach(GWPAddToCartWrapper => {
            if (GWPAddToCartWrapper.querySelector('input').getAttribute('value') == gwpProductId){
              GWPAddToCartWrapper.querySelector('.atb-ajax-plp').innerText = 'Added'
            } else {
            }
          })

        }
      })

      if (hasGwpItem){
        GWPAddToCartWrappers.forEach(GWPAddToCartWrapper => {
          const addToCart = GWPAddToCartWrapper.querySelector('.add-to-cart')
          addToCart.setAttribute('disabled', true)
        })
      } else {
        GWPAddToCartWrappers.forEach(GWPAddToCartWrapper => {
          const addToCart = GWPAddToCartWrapper.querySelector('.add-to-cart')
          addToCart.removeAttribute('disabled')
          GWPAddToCartWrapper.querySelector('.atb-ajax-plp').innerText = 'Add'

        })
      }
    }

    // remove gwp item when total falls bellow threshold
    function removeGwpSectionItem(totalCartPrice, cartItems) {
      if (gwpSectionThreshold) {
        if (
          gwpSectionThreshold != "" &&
          Number(totalCartPrice) <= Number(gwpSectionThreshold)
        ) {      
          let data = {}
          let hasGwpItem = false
          gwpProductArray.forEach(gwpProductId => {

          // check if cart conatins gwp item
          if (cartItems.filter((item) => item.id == parseInt(gwpProductId)).length > 0) {
            hasGwpItem = true
            data[Number(gwpProductId)] = 0;
          }
          // set gwp item to be removed
     
        })

        if (hasGwpItem) {
          fetch("/cart/update.js", {
            body: JSON.stringify({ updates: data }),
            credentials: "same-origin",
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              "X-Requested-With": "XMLHttpRequest", // This is needed as currently there is a bug in Shopify that assumes this header
            },
          })
          .then(() => {
            document.dispatchEvent(new CustomEvent("cart:build"));
          })
        }
      }
    }
  }
    
// start regular GWP functions
  function addGwpItem(totalCartPrice, cartItems) {
    if (freeGwpProductIdTier1 != "" && freeGwpThresholdTier1 != "") {
      let data;
      const hasGwpItem =
        cartItems.filter((item) => item.id === freeGwpProductIdTier1).length >
        0;

      if (
        freeGwpProductIdTier1 &&
        Number(totalCartPrice) >= Number(freeGwpThresholdTier1) &&
        !hasGwpItem && freeGwpProductTier1InStock
      ) {
        data = {
          quantity: 1,
          id: Number(freeGwpProductIdTier1),
        };

        fetch("/cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(data),
        })
          .then((response) => response.json())
          .then((data) => {
            addGwpItemTier2(totalCartPrice, cartItems);
            document.dispatchEvent(new CustomEvent("cart:build"));
          });
      } else {
        addGwpItemTier2(totalCartPrice, cartItems);
      }
    }
  }

  function addGwpItemTier2(totalCartPrice, cartItems) {
    if (freeGwpProductIdTier2 != "" && freeGwpThresholdTier2 != "") {
      let data;
      const hasGwpItem2 =
        cartItems.filter((item) => item.id === Number(freeGwpProductIdTier2))
          .length > 0;

      if (
        freeGwpProductIdTier2 != "" &&
        Number(totalCartPrice) >= Number(freeGwpThresholdTier2) &&
        !hasGwpItem2 && freeGwpProductTier2InStock
      ) {
        data = {
          quantity: 1,
          id: Number(freeGwpProductIdTier2),
        };

        fetch("/cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(data),
        })
          .then((response) => response.json())
          .then((data) => {
            document.dispatchEvent(new CustomEvent("cart:build"));
          });
      }
    }
  }

  function removeGwpItem(totalCartPrice) {
    if (freeGwpProductIdTier1 != "" && freeGwpThresholdTier1 != "") {
      const data = {};
      let hasGwpToRemove = false;
      if (
        freeGwpProductIdTier1 &&
        Number(totalCartPrice) < Number(freeGwpThresholdTier1)
      ) {
        data[Number(freeGwpProductIdTier1)] = 0;
        hasGwpToRemove = true;
      }

      if (hasGwpToRemove) {
        fetch("/cart/update.js", {
          body: JSON.stringify({ updates: data }),
          credentials: "same-origin",
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-Requested-With": "XMLHttpRequest", // This is needed as currently there is a bug in Shopify that assumes this header
          },
        }).then(() => {
          document.dispatchEvent(new CustomEvent("cart:build"));
          removeGwpItemTier2(totalCartPrice);
        });
      } else {
        removeGwpItemTier2(totalCartPrice);
      }
    }
  }

  function removeGwpItemTier2(totalCartPrice) {
    if (freeGwpProductIdTier2 != "" && freeGwpThresholdTier2 != "") {
      const data = {};
      let hasGwpToRemove2 = false;

      if (
        freeGwpProductIdTier2 != "" &&
        Number(totalCartPrice) < Number(freeGwpThresholdTier2)
      ) {
        data[Number(freeGwpProductIdTier2)] = 0;
        hasGwpToRemove2 = true;
      }

      if (hasGwpToRemove2) {
        fetch("/cart/update.js", {
          body: JSON.stringify({ updates: data }),
          credentials: "same-origin",
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-Requested-With": "XMLHttpRequest", // This is needed as currently there is a bug in Shopify that assumes this header
          },
        }).then(() => {
          document.dispatchEvent(new CustomEvent("cart:build"));
        });
      }
    }
  }
  return init();
}

window.addEventListener("DOMContentLoaded", () => {
  cartEvents();
});
